var map = {
	"./general/DocsIcon--bluecheckmark.svg": 1445,
	"./general/DocsIcon--country.svg": 1446,
	"./general/DocsIcon--github.svg": 1447,
	"./general/DocsIcon--guide.svg": 1448,
	"./general/DocsIcon--list.svg": 1449,
	"./general/DocsIcon--locale.svg": 1450,
	"./general/DocsIcon--thumbsdown.svg": 1451,
	"./general/DocsIcon--thumbsup.svg": 1452,
	"./general/DocsIcon--video.svg": 1453,
	"./nav/DocsIcon--account.svg": 1454,
	"./nav/DocsIcon--business.svg": 1455,
	"./nav/DocsIcon--developertools.svg": 1456,
	"./nav/DocsIcon--financialservices.svg": 1457,
	"./nav/DocsIcon--home.svg": 1458,
	"./nav/DocsIcon--mobilenav.svg": 1459,
	"./nav/DocsIcon--payments.svg": 1460,
	"./nav/DocsIcon--reference.svg": 1461,
	"./nav/DocsIcon--security.svg": 1462,
	"./product/DocsIcon--account.svg": 1463,
	"./product/DocsIcon--atlas.svg": 1464,
	"./product/DocsIcon--capital.svg": 1465,
	"./product/DocsIcon--checkout.svg": 1466,
	"./product/DocsIcon--climate.svg": 1467,
	"./product/DocsIcon--connect.svg": 1468,
	"./product/DocsIcon--corporatecard.svg": 1469,
	"./product/DocsIcon--dashboard.svg": 1470,
	"./product/DocsIcon--developertools.svg": 1471,
	"./product/DocsIcon--elements.svg": 1472,
	"./product/DocsIcon--gateddocs.svg": 1473,
	"./product/DocsIcon--identity.svg": 1474,
	"./product/DocsIcon--implementationguides.svg": 1475,
	"./product/DocsIcon--invoicing.svg": 1476,
	"./product/DocsIcon--issuing.svg": 1477,
	"./product/DocsIcon--partners.svg": 1478,
	"./product/DocsIcon--payments.svg": 1479,
	"./product/DocsIcon--radar.svg": 1480,
	"./product/DocsIcon--reporting.svg": 1481,
	"./product/DocsIcon--sigma.svg": 1482,
	"./product/DocsIcon--styleguide.svg": 1483,
	"./product/DocsIcon--tax.svg": 1484,
	"./product/DocsIcon--terminal.svg": 1485,
	"./product/DocsIcon--treasury.svg": 1486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1444;